// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__lT9Av","text":"Button_text__XtEX0","icon":"Button_icon__UGLFQ"};